import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Paper, Typography, Card, CardContent, Button, Stack, Box, Dialog } from '@mui/material';
import axios from '../../axiosInstance';
import defaultThumbnail from '../../assets/eBraryIcon.png';
import RecommendedBooks from '../../components/RecommendedBooks_Ebrary';
import SearchBox_ebrary from '../../components/SearchBox_ebrary_journals';
import { styled } from '@mui/system';

const Journal_Details = ({ onSearch, initialQuery }) => {
  const [username, setUsername] = useState(null); // Store the username
  const [displayname, setDisplayname] = useState(null); // Store the username
  const [courseIds, setCourseIds] = useState(null); // Store the username
  const [collegeId, setCollegeId] = useState(null); // Store the username
  const [inputValue, setInputValue] = useState(initialQuery || '');
  const navigate = useNavigate();
  const location = useLocation();
  const [pdfUrl, setPdfUrl] = useState(null);

  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const [notifications, setNotifications] = useState([
    { id: 1, message: "New book added to your course", read: false },
    { id: 2, message: "Your library subscription expires soon", read: false }
  ]);
  const [notificationOpen, setNotificationOpen] = useState(false);
  const unreadCount = notifications.filter((n) => !n.read).length;

  
  const { id: bookId } = useParams();

  const [item, setItem] = useState(null);
  const [recommendedBooks, setRecommendedBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


    
    useEffect(() => {
      const user = JSON.parse(localStorage.getItem('user'));
      if (user) {
        setUsername(user.username);  // Set username if user is logged in
        setCourseIds(user.courseIds);
        setCollegeId(user.collegeId);
        setDisplayname(user.displayname);
      }
    }, []);



  const { id } = useParams();



const handleNavigate = () => {
  navigate(`/journal_articles/${item.id}`); // Navigate with the journal ID
};

useEffect(() => {
  const fetchItem = async () => {
      if (!id) { // Use `id` from `useParams`
          setError('No article ID provided.');
          return;
      }

      setLoading(true);
      try {
          const response = await axios.get(`https://api.openalex.org/sources/${id}`);
          const data = response.data;

          setItem({
              id: data.id.replace('https://openalex.org/', ''), // Extract ID
              title: data.display_name,
              publisher: data.host_organization_name,
              issn: data.issn_l || 'N/A',
              totalWorks: data.works_count || 'N/A',
              publisherURL: data.homepage_url || 'N/A',
              impactFactor: data["summary_stats"]?.["2yr_mean_citedness"] || 'N/A',
              hIndex: data["summary_stats"]?.h_index || 'N/A',
              i10Index: data["summary_stats"]?.i10_index || 'N/A',
              isOA: data.is_oa ? 'YES' : 'NO',
              isDOAJ: data.is_in_doaj ? 'YES' : 'NO',
              APC: data.apc_usd || 'N/A',
              subjects: data.x_concepts?.map(concept => concept.display_name).join(', ') || 'N/A',
          });
      } catch (error) {
          console.error('Error fetching item details:', error.message, error.response?.data || 'No additional details');
          setError('Failed to fetch item details.');
      } finally {
          setLoading(false);
      }
  };

  fetchItem();
}, [id]);

if (loading) return <Typography>Loading...</Typography>;
if (error) return <Typography>{error}</Typography>;


const SearchResultsWrapper = styled(Box)(({ theme }) => ({
  width: '60%', // Default for larger screens
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  minHeight: '500px',
  [theme.breakpoints.down('md')]: {
    width: '100%', // Full width on medium screens or smaller
    paddingLeft: 5,
    paddingRight: 5,
  },
}));

const YouTubeResultsWrapper = styled(Box)(({ theme }) => ({
  width: '40%', // Default for larger screens
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  minHeight: '500px',
  [theme.breakpoints.down('md')]: {
    width: '100%', // Full width on medium screens or smaller
    paddingLeft: 0,
  },
}));


  return (
    <main className="flex-grow p-1">


    <div className="bg-gray-100 text-gray-900 flex flex-col min-h-full">

    <div className="flex-1 flex flex-col p-1 bg-gradient-to-br from-gray-50 to-gray-200">
    <SearchBox_ebrary />

<br />
<Box
  className="main-content"
  sx={{
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' }, // column on mobile, row on desktop
  }}
>
      <SearchResultsWrapper>
      <Typography variant="h5" sx={{ color: 'primary.main', fontWeight: 'bold' }}>
        {item.title}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' }, // Stack on mobile
          gap: 2,
        }}
      >
            <img src={item.thumbnail || defaultThumbnail} alt="Thumbnail" style={{ width: '20%', height: '30%', borderRadius: 5 }} />
            <Box sx={{ flex: 1 }}>
            <Stack spacing={0.75}>
            <Typography sx={{ color: 'text.secondary' }}>
                <strong>Total Articles Published:</strong> {item.totalWorks}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ marginBottom: 1 }}>
                <strong>ISSN:</strong> {item.issn} | <strong>Publisher:</strong> {item.publisher}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ marginBottom: 1 }}>
              <strong>URL:</strong> 
                {item.publisherURL ? (
                  <a href={item.publisherURL} target="_blank" rel="noopener noreferrer">
                    {item.publisherURL}
                  </a>
                ) : (
                  "N/A"
                )}
              </Typography>
              <Typography sx={{ marginBottom: 1, color: 'text.secondary' }}>
                <strong>Metrics:</strong> {Math.round(item.impactFactor * 100) / 100} (IF), {item.hIndex} (H-Index)
              </Typography>
              </Stack>

            </Box>
          </Box>
          <Box sx={{ marginTop: 2 }}>




            <Typography sx={{ color: 'primary.main' }}>
                <strong>Subject:</strong> {item.subjects}
            </Typography>

            <Button
              sx={{ 
                color: 'white', 
                background: '#FFB300', 
                marginTop: 2,
                border: '1px solid transparent', // Default border
                '&:hover': {
                  backgroundColor: '#FFA500', // Change to your desired hover color
                  borderColor: '#007bff', // Optional: Change border color on hover
                }
              }}
              onClick={handleNavigate} // Attach the navigation handler
            >
              Browse Journal Articles
            </Button>
            
          </Box>

          </SearchResultsWrapper>

          <YouTubeResultsWrapper>
            <RecommendedBooks
              course={item.course}
              subject={item.subject}
              semester={item.semester}
              currentBookId={item.id}
            />
          </YouTubeResultsWrapper>
</Box>


    </div>
          </div>
          </main>
  );
};

export default Journal_Details;
